import _ from 'lodash';

import { createSelector } from 'reselect';

export const getUserState = state => _.get(state, 'user');

export const getControlPin = createSelector(
  [getUserState],
  user => _.get(user, 'statusControlPin'),
);

export const getPinPurchase = createSelector(
  [getControlPin],
  controlPin => _.get(controlPin, ['pin_purchase', 'status'], 0),
);

export const getUserType = createSelector(
  [getUserState],
  user => _.get(user, 'userType'),
);

export const getPinParental = createSelector(
  [getControlPin],
  controlPin => _.get(controlPin, ['pin_parental', 'status'], 0),
);

export const getPinChannel = createSelector(
  [getControlPin],
  controlPin => _.get(controlPin, ['pin_channel', 'status'], 0),
);

export const getRatingValue = createSelector(
  [getControlPin],
  controlPIN => _.get(controlPIN, ['pin_parental', 'info', 'value'], 20),
);

export const getPINs = createSelector(
  [getPinPurchase, getPinParental, getPinChannel],
  (pin_purchase, pin_parental, pin_channel) => ({
    pin_purchase,
    pin_parental,
    pin_channel,
  }),
);

export const getBooleanPins = createSelector(
  [getPINs],
  pins => _.map(pins, (value, key) => ({ [key]: !!+value })),
);

export const getPINSforActivate = createSelector(
  [getPinPurchase, getPinParental, getPinChannel],
  (status_purchase_pin, status_parental_pin, status_channel_pin) => ({
    status_purchase_pin,
    status_parental_pin,
    status_channel_pin,
  }),
);

export const getBooleanPinsForActivate = createSelector(
  [getPINSforActivate],
  pins => _.map(pins, (value, key) => ({ [key]: !!+value })),
);

export const hasPinEnabled = createSelector(
  [getBooleanPins],
  pins => _.some(pins),
);

export const getUserHash = createSelector(
  [getUserState],
  user => _.get(user, 'userhash'),
);

export const getHasUserLoggedIn = createSelector(
  [getUserHash],
  userHash => !_.isEmpty(userHash),
);

export const getUserID = createSelector(
  [getUserState],
  user => _.get(user, 'user_id'),
);

export const getUserEmail = createSelector(
  [getUserState],
  user => _.get(user, 'username'),
);

export const getUserFirstName = createSelector(
  [getUserState],
  user => _.get(user, 'firstname'),
);

export const getUserLastName = createSelector(
  [getUserState],
  user => _.get(user, 'lastname'),
);

export const getUserProfile = createSelector(
  [getUserState],
  user => _.get(user, 'profile'),
);

export const getListPaymentMethod = createSelector(
  [getUserProfile],
  profile => _.get(profile, 'paymentMethods'),
);

function transformArrayToObjectKeys(array, keys) {
  return array.reduce(
    (objectKey, data, index) => ({ ...objectKey, [keys[index]]: data }),
    {},
  );
}

export const getListPaymentMethodWithoutDisabled = createSelector(
  [getListPaymentMethod],
  (paymentMethods = []) =>
    paymentMethods.filter(paymentMethod => paymentMethod.status !== 'DISABLED'),
);

export const getUserDataToClaroPagos = createSelector(
  [
    getUserID,
    getUserFirstName,
    getUserLastName,
    getUserEmail,
    getListPaymentMethodWithoutDisabled,
  ],
  (...user) =>
    transformArrayToObjectKeys(user, [
      'userId',
      'firstName',
      'lastName',
      'email',
      'listPaymentMethod',
    ]),
);

export const getUserToken = createSelector(
  [getUserState],
  user => _.get(user, 'token'),
);

export const getRegion = createSelector(
  [getUserState],
  user => _.get(user, 'region'),
);

export const getUserPaywayProfile = createSelector(
  [getUserState],
  user => _.get(user, 'profile'),
);

function serialize(collection, serializeFn) {
  const serialized = _.reduce(collection, serializeFn, '');
  return _.trimEnd(serialized, '-');
}

function serializePaymentMethods(paymentMethods) {
  return serialize(paymentMethods, (serialized, method) => {
    if (_.isEmpty(method.user_category)) return serialized;
    return serialized.concat(`${method.user_category}-`);
  });
}

function serializeSubscriptions(subs) {
  return serialize(subs, (serialized, subscription) => {
    if (_.isEmpty(subscription.key)) return serialized;
    return serialized.concat(`${subscription.key}-`);
  });
}

export const getYouboraExtraParams = createSelector(
  [getUserPaywayProfile, getUserEmail],
  (paywayProfile, userEmail) => {
    return {
      paymentMethods: paywayProfile
        ? serializePaymentMethods(paywayProfile.paymentMethods)
        : '',
      subscriptions: paywayProfile
        ? serializeSubscriptions(paywayProfile.subscriptions)
        : '',
      username: userEmail,
    };
  },
);
